import { IConfig } from './IConfig';
import { Enviroment, IConfigService } from './IConfigService';

export const ProdSubDomains = [
    'ADMIN', 'OFFICER', 'LEGAL', 'CARTORIO', 'APP',
    'ADMIN2', 'OFFICER2', 'LEGAL2', 'CARTORIO2', 'APP2', 'DECODE'
]

const miscellaneousConfig = {
    gATracking: "UA-128076428-1",
    hotjarId: "1082572",
    hotjarSV: "6",
    gTag: "GTM-TLT2PTG",
    fbAppId: "551236288706917",
    googleAppId: "1049493526687-41s8e31v8a0v88ev8lp9hl4ug0oeqthi.apps.googleusercontent.com",
};

const defaultConfig = {
    baseUrl: "admin",
    version: "app_version_admin"
}

/** Nome do Identity Provider no Cognito — deve ser idêntico ao cadastrado no console AWS */
const ENTRA_IDP_NAME = "MicrosoftEntra";

/**
 * Domínios Cognito Hosted UI por ambiente.
 * Substitua pelos domínios reais após criar o domain no User Pool (passo a passo AWS no final da implementação).
 * Formato: <prefix>.auth.<region>.amazoncognito.com (sem https://)
 */
const CognitoDomains = {
    LocalHost: "precatorios-admin-dev.auth.sa-east-1.amazoncognito.com",
    Development: "precatorios-admin-dev.auth.sa-east-1.amazoncognito.com",
    Staging: "precatorios-admin-uat.auth.us-east-1.amazoncognito.com",
    Production: "precatorios-admin.auth.sa-east-1.amazoncognito.com",
} as const;

const ConfigService: IConfigService = {
    enviroments: {
        LocalHost: {
            env: 'LocalHost',
            apiUrl: 'https://localhost:44300/api',
            baseUrl: defaultConfig.baseUrl,
            version: defaultConfig.version,
            gRecaptcha: '6LdStg4cAAAAAJfkKxvrVsJzzF4WVP1R8pn_Q39q',
            miscellaneousConfig,
            awsConfig: {
                cognitoUserPoolId: "sa-east-1_fjLFQz5ko",
                cognitoRegion: "sa-east-1",
                userPoolWebClientId: "1irt0a4g73qpca71rqpn6qfo14",
                userPoolIdentityPoolId: "sa-east-1:5cc73c52-30ec-426a-84a5-f60bd2f2aa83",
                userPoolIdentityId: "sa-east-1:5cc73c52-30ec-426a-84a5-f60bd2f2aa83",
                cognitoDomain: CognitoDomains.LocalHost,
                entraIdentityProviderName: ENTRA_IDP_NAME,
                oauthRedirectSignIn: ["http://localhost:3000/login"],
                oauthRedirectSignOut: ["http://localhost:3000/login"],
                entraLoginEnabled: true,
            }
        },
        Development: {
            env: 'Development',
            apiUrl: 'https://api-dev.precatoriosbrasil.com/api',
            baseUrl: defaultConfig.baseUrl,
            version: defaultConfig.version,
            gRecaptcha: '6LdStg4cAAAAAJfkKxvrVsJzzF4WVP1R8pn_Q39q',
            miscellaneousConfig,
            awsConfig: {
                cognitoUserPoolId: "sa-east-1_fjLFQz5ko",
                cognitoRegion: "sa-east-1",
                userPoolWebClientId: "1irt0a4g73qpca71rqpn6qfo14",
                userPoolIdentityPoolId: "sa-east-1:5cc73c52-30ec-426a-84a5-f60bd2f2aa83",
                userPoolIdentityId: "sa-east-1:5cc73c52-30ec-426a-84a5-f60bd2f2aa83",
                cognitoDomain: CognitoDomains.Development,
                entraIdentityProviderName: ENTRA_IDP_NAME,
                oauthRedirectSignIn: ["https://precatoriosbrasil-admin-dev.pactual.net/login"],
                oauthRedirectSignOut: ["https://precatoriosbrasil-admin-dev.pactual.net/login"],
                entraLoginEnabled: true,
            }
        },
        Staging: {
            env: 'Staging',
            apiUrl: 'https://api-uat.precatoriosbrasil.com/api',
            baseUrl: defaultConfig.baseUrl,
            version: defaultConfig.version,
            gRecaptcha: '6LdStg4cAAAAAJfkKxvrVsJzzF4WVP1R8pn_Q39q',
            miscellaneousConfig,
            awsConfig: {
                cognitoUserPoolId: "us-east-1_X6iUeytCu",
                cognitoRegion: "us-east-1",
                userPoolWebClientId: "2p3vrml4r91m1v93nctgbrjqlb",
                userPoolIdentityPoolId: "us-east-1:2211819c-d0ad-45a3-b23d-adbb59e24f93",
                userPoolIdentityId: "us-east-1:2211819c-d0ad-45a3-b23d-adbb59e24f93",
                cognitoDomain: CognitoDomains.Staging,
                entraIdentityProviderName: ENTRA_IDP_NAME,
                oauthRedirectSignIn: ["https://precatoriosbrasil-admin-uat.pactual.net/login"],
                oauthRedirectSignOut: ["https://precatoriosbrasil-admin-uat.pactual.net/login"],
                entraLoginEnabled: true,
            }
        },
        Production: {
            env: 'Production',
            apiUrl: 'https://api.precatoriosbrasil.com/api',
            baseUrl: defaultConfig.baseUrl,
            version: defaultConfig.version,
            gRecaptcha: '6LdStg4cAAAAAJfkKxvrVsJzzF4WVP1R8pn_Q39q',
            miscellaneousConfig,
            awsConfig: {
                cognitoUserPoolId: "sa-east-1_xsQBfAnF5",
                cognitoRegion: "sa-east-1",
                userPoolWebClientId: "4hffcagt2imkvr3o2k4hbeo3r1",
                userPoolIdentityPoolId: "sa-east-1:84caa294-fc0c-4c38-964d-bd3a3138eca6",
                userPoolIdentityId: "sa-east-1:84caa294-fc0c-4c38-964d-bd3a3138eca6",
                cognitoDomain: CognitoDomains.Production,
                entraIdentityProviderName: ENTRA_IDP_NAME,
                oauthRedirectSignIn: [
                    "https://admin.precatoriosbrasil.com/login",
                ],
                oauthRedirectSignOut: [
                    "https://admin.precatoriosbrasil.com/login",
                ],
                entraLoginEnabled: true,
            }
        }
    },

    getEnv(): Enviroment {
        const host = location.hostname.toUpperCase();
        const subDomain = host.split('.')[0];

        // UAT: admin-uat / precatoriosbrasil-admin-uat.pactual.net
        if (host.includes("-UAT") || subDomain.includes("-UAT")) {
            return "Staging";
        }
        // DEV: admin-dev / precatoriosbrasil-admin-dev.pactual.net
        if (host.includes("-DEV") || subDomain.includes("-DEV")) {
            return "Development";
        }
        // PROD: ADMIN, ADMIN2, ou precatoriosbrasil-admin.pactual.net
        if (
            ProdSubDomains.includes(subDomain) ||
            (host.includes("PACTUAL.NET") && host.includes("ADMIN") && !host.includes("-UAT") && !host.includes("-DEV"))
        ) {
            return "Production";
        }

        return "LocalHost";
    },

    getConfig(): IConfig {
        const env = this.getEnv();
        const enviroment = this.enviroments[env]!;
        return enviroment;
    },

    isEntraLoginAvailable(): boolean {
        const { awsConfig } = this.getConfig();
        return !!(
            awsConfig.entraLoginEnabled &&
            awsConfig.cognitoDomain &&
            awsConfig.entraIdentityProviderName
        );
    }
}

export default ConfigService;
